import placeholder from "../assets/images/placeholder.png";

/* ── Fallback photos per RSS category (used when a feed item has no usable image) ──
   Files live in public/assets/images/rss (Unsplash photos, free to use under the Unsplash License) */
const rssImg = (name) => `/assets/images/rss/${name}.webp`;

const CATEGORY_IMAGES = {
  education: ["education-1", "education-2", "education-3", "education-4", "education-5"],
  parenting: ["parenting-1", "parenting-2", "parenting-3", "parenting-4"],
  "child development": [
    "child-development-1",
    "child-development-2",
    "child-development-3",
    "child-development-4",
  ],
  "baby care": ["baby-care-1", "baby-care-2", "baby-care-3", "parenting-4"],
  "teen behavior": ["teen-behavior-1", "teen-behavior-2"],
  health: ["health-1", "health-2", "health-3"],
  "mental health": ["mental-health-1", "mental-health-2"],
};

const DEFAULT_IMAGES = ["parenting-1", "child-development-4", "child-development-1", "parenting-3"];

// Stable hash so the same article always gets the same photo,
// while articles in the same category get different ones.
const hashString = (str = "") => {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h);
};

export const getCategoryImage = (item) => {
  const ids =
    CATEGORY_IMAGES[item?.category?.toLowerCase().trim()] || DEFAULT_IMAGES;
  const key = item?.title || item?.link || "";
  return rssImg(ids[hashString(key) % ids.length]);
};

// source.unsplash.com (used by the old RSS sync as a fallback) has been shut down,
// so treat those URLs as missing too.
export const getRssImage = (item) =>
  item?.image && !item.image.includes("source.unsplash.com")
    ? item.image
    : getCategoryImage(item);

// If the feed's own image fails, try the category photo; if that fails too, use the local placeholder.
export const handleRssImageError = (item) => (e) => {
  const img = e.currentTarget;
  const fallback = getCategoryImage(item);
  if (img.dataset.fallback !== "category" && !img.src.endsWith(fallback)) {
    img.dataset.fallback = "category";
    img.src = fallback;
  } else {
    img.onerror = null;
    img.src = placeholder;
  }
};
